import {HttpClient,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {JhiAlert,JhiAlertService} from 'ng-jhipster';
import {BehaviorSubject,Observable,Subject} from 'rxjs';
import {SERVER_API_URL} from 'src/app/app.constants';
import {TdisConstants} from 'src/app/shared/constants/tdis-constants';
import {TypeOfClient} from 'src/app/shared/model/client.model';
import {FinscanEntity} from 'src/app/shared/model/fin-scan-opportunities.model';
import {FinsacnApplicationId} from 'src/app/shared/model/finscan-status.enum';
import {IInternalStaffPermissionDto} from 'src/app/shared/model/internal-staff-permission-dto.model';
import {IUserIdentity} from 'src/app/shared/model/user-identity.modal';
import {CommonUtils} from 'src/app/shared/util/common-utils';
import {RoleUtil} from 'src/app/shared/util/role-util';
import {Clients} from 'src/environments/clients';
import {environment} from 'src/environments/environment';
import {AccountService} from './account.service';



@Injectable({providedIn: 'root'})
export class Principal {
    public readonly RoleUtil = RoleUtil;
    showAlertOnCancel: BehaviorSubject<boolean>  = new BehaviorSubject<boolean>(false);
    // currentPage: BehaviorSubject<string> = new BehaviorSubject<string>("");
    currentPage:string = "Trader";
    private resourceUrl=SERVER_API_URL+'api/';
    userIdentity: IUserIdentity;
    staffPermission: IInternalStaffPermissionDto;
    private authenticated=false;
    private authenticationState=new Subject<any>();
    private isStaff: boolean;
    sortColumn: string='';
    reverseSort: boolean;
    public isShowPastHistory: boolean=true;
    public isShowFutureHistory: boolean=true;
    //only for client and client staff
    // public isStorageScope: boolean = false;
    public applySorting: boolean=false;
    public isHistoryFuturePopupShown: boolean=false;
    public showContent: boolean=false;
    public loggedInUserEmail: any;
    public isCreatedByAdmin=false;
    
    public showClaims=environment.claimEnabled;
    public showSpot=environment.spotEnabled;
    public alreadyCalled=false;
    private login=environment.login;

    readonly TdisConstants = TdisConstants;

    constructor(
        private titleService: Title,
        private account: AccountService,
        private http: HttpClient
    ) {
       
    }

    

    public setTitle(newTitle: string) {
        this.titleService.setTitle('TDIS | '+newTitle);
    }

    authenticate(identity) {
        this.userIdentity=identity;
        this.authenticated=identity!==null;
        this.authenticationState.next(this.userIdentity);
        this.staffPermission=this.userIdentity!==null? this.userIdentity.internalStaffPermissionDTO:null;
        this.isStaff=this.userIdentity!=null? this.userIdentity.isStaff:null;
    }

    hasAnyAuthorityAccess(authorities: string[],permission: string): Promise<boolean> {
        if(this.hasAnyAuthorityDirect(authorities)&&this.hasStaffPermission(permission)) {
            return Promise.resolve(true);
        } else {
            return Promise.resolve(false);
        }
    }

    hasAnyAuthorityNoAccess(authorities: string[],permission: string): Promise<boolean> {
        if(!(this.hasAnyAuthorityDirect(authorities))&&this.hasStaffPermission(permission)) {
            return Promise.resolve(true);
        } else {
            return Promise.resolve(false);
        }
    }

    hasAnyAuthority(authorities: string[]): Promise<boolean> {
        return Promise.resolve(this.hasAnyAuthorityDirect(authorities));
    }

    // hasAnyAuthorityDirect(authorities: string[]): boolean {
    //     if (!this.authenticated || !this.userIdentity || !this.userIdentity.authorities) {
    //         return false;
    //     }

    //     for (let i = 0; i < authorities.length; i++) {
    //         if (this.userIdentity.authorities.includes(authorities[i])) {
    //             return true;
    //         }
    //     }

    //     return false;
    // }

    hasAnyAuthorityDirect(authorities: string[]): boolean {
        if(!this.authenticated||!this.userIdentity||!this.userIdentity.authorities) return false;
        return this.checkAuthrorities(authorities);
    }

    checkAuthrorities(authorities: string[]) {
        // for(let i=0;i<authorities.length;i++) {
        //     if(this.userIdentity.authorities.includes(authorities[ i ])) {
        //         return true;
        //     }
        // }

        for(let _authority of authorities) {
            if(this.userIdentity.authorities.includes(_authority)) {
                return true;
            }
        }

        return false;
    }

    // method to check if user id autheticated and having authorities
    isAuthenticatedAndHaveAuthrorities() {
        return this.authenticated&&this.userIdentity&&this.userIdentity.authorities;
    }


    hasAuthority(authority: string): Promise<boolean> {
        if(!this.authenticated) {
            return Promise.resolve(false);
        }

        return this.identity().then(
            id => {
                return Promise.resolve(id.authorities&&id.authorities.includes(authority));
            },
            () => {
                return Promise.resolve(false);
            }
        );
    }

    identity(force?: boolean): Promise<any> {
        if(CommonUtils.isTrue(force)) {
            this.userIdentity = undefined;
        }

        // check and see if we have retrieved the userIdentity data from the server.
        // if we have, reuse it by immediately resolving
        if(this.userIdentity) {
            // this.getStorageScope();
            return Promise.resolve(this.userIdentity);
        }

       
        // retrieve the userIdentity data from the server, update the identity object, and then resolve.
        return this.account
            .get()
            .toPromise()
            .then(response => {
                const account: any=response.body;
                if(account) {
                    this.userIdentity=account;
                    this.authenticated=true;
                    this.staffPermission=this.userIdentity!==null? this.userIdentity.internalStaffPermissionDTO:null;
                    this.isStaff=this.userIdentity.isStaff;
                    this.loggedInUserEmail=this.userIdentity.login;
                    this.isCreatedByAdmin=this.userIdentity.isCreatedByAdmin;
                    console.log(this.userIdentity," this.userIdentity");
                    
                } else {
                    this.userIdentity=null;
                    this.authenticated=false;
                }
                // this.getStorageScope();
                this.authenticationState.next(this.userIdentity);
                return this.userIdentity;
            })
            .catch(err => {
                this.userIdentity=null;
                this.authenticated=false;
                this.authenticationState.next(this.userIdentity);
                return null;
            });
    }

    isAuthenticated(): boolean {
        return this.authenticated;
    }

    isIdentityResolved(): boolean {
        return this.userIdentity!==undefined;
    }

    getAuthenticationState(): Observable<any> {
        return this.authenticationState.asObservable();
    }

    getImageUrl(): string {
        return this.isIdentityResolved()? this.userIdentity.imageUrl:null;
    }

    get authority() {
        if(this.userIdentity) {
            return this.userIdentity.authorities[ 0 ];
        }
        return null;
    }

    get createdByUserRole() {
        return this.userIdentity.createdByUserRole;
    }
    // for underwriter
    get createdBySuperAdminRole() {
        return this.userIdentity.createdBySuperAdminRole;
    }
    getStaffPermission() {
        return this.userIdentity.internalStaffPermissionDTO;
    }

    get lossPayeePermission(): boolean {
        if(this.isAStaff()) {
            return this.getStaffPermission().policyInfo && this.getStaffPermission().lossPayee;
        } else {
            return true;
        }
    }

    get storageDeclaration() {
        if(this.isAStaff()) {
            return this.getStaffPermission().storageDeclaration;
        } else {
            return true;
        }
    }

    get getCertificatePermission() {
        if(this.isAStaff()) {
            return this.getStaffPermission().certificate;
        } else {
            return true;
        }
    }
    get getCertificateClientManagement() {
        if(this.isAStaff()) {
            return this.getStaffPermission().certificateClientManagement;
        } else {
            return true;
        }
    }
    isAStaff(): boolean {
        return this.userIdentity.isStaff;
    }

    isTrader(): boolean {
        if(((this.authority===RoleUtil.Role.CLIENT_STAFF)||(this.authority===RoleUtil.Role.CLIENT))&&(this.userIdentity.typeOfClient === TypeOfClient.TRADER)) {
            return true;
        }
        return false;
    }
    isFreightForwarder(): boolean {
        if(((this.authority==RoleUtil.Role.CLIENT_STAFF)||(this.authority==RoleUtil.Role.CLIENT))&&(this.userIdentity.typeOfClient === TypeOfClient.FREIGHT_FORWARDER)) {
            return true;
        }
        return false;
    }

    isAllowedBulkDeclaration(): boolean {
        if(((this.authority===RoleUtil.Role.CLIENT_STAFF)||(this.authority===RoleUtil.Role.CLIENT))&&(this.userIdentity.typeOfClient === TypeOfClient.TRADER) && this.userIdentity.isAllowedBulkDeclaration) {
            return true;
        }
        return false;
    }

    hasBrokerPermission(authority: string[]): Promise<boolean> {
        if(this.hasAnyAuthorityDirect(authority)) {
            if(this.createdBySuperAdminRole&&(this.createdBySuperAdminRole==RoleUtil.Role.UNDERWRITER||this.createdBySuperAdminRole==RoleUtil.Role.UNDERWRITER_STAFF)) {
                return Promise.resolve(false);
            } else {
                return Promise.resolve(true);
            }
        } else {
            return Promise.resolve(true);
        }
        
    }
    hasStaffPermission(authority: string): Promise<boolean> {
        if(!this.authenticated) {
            return Promise.resolve(false);
        }

        if(authority === 'esgCarboncare' ){
            return Promise.resolve( this.userIdentity.enableEsgCarboncare); 
        }
        
        //for trader client and client staff 
        if(authority==='myBulkDeclaration') {
            if((this.authority===RoleUtil.Role.BROKER_STAFF||this.authority===RoleUtil.Role.UNDERWRITER_STAFF||this.authority===RoleUtil.Role.INSURER_STAFF)) {
                return Promise.resolve(this.staffPermission.myBulkDeclaration);
            }
            else if(this.userIdentity.typeOfClient === TypeOfClient.TRADER) {
                if(this.authority===RoleUtil.Role.CLIENT_STAFF&&this.userIdentity.isAllowedBulkDeclaration) {
                    return Promise.resolve(this.staffPermission.myBulkDeclaration);
                } else if(this.authority===RoleUtil.Role.CLIENT) {
                    return Promise.resolve(this.userIdentity.isAllowedBulkDeclaration);
                } else {
                    return Promise.resolve(false);
                }
            } else if(this.userIdentity.typeOfClient === TypeOfClient.FREIGHT_FORWARDER) {
                return Promise.resolve(false);
            }
            else {
                return Promise.resolve(true);
            }
        }

        if(authority==='vesselScreening') {
            if((this.authority===RoleUtil.Role.CLIENT_STAFF||this.authority===RoleUtil.Role.CLIENT)&&!(this.userIdentity.typeOfClient === TypeOfClient.TRADER)) {
                return Promise.resolve(false);
            } else if(!this.isStaff) {
                return Promise.resolve(true);
            } else {
                return Promise.resolve(this.staffPermission.vesselScreening);
            }
            
        }

        if(authority==='accouting_access') {
            if((this.authority===RoleUtil.Role.CLIENT_STAFF||this.authority===RoleUtil.Role.CLIENT)) {
                return Promise.resolve(this.userIdentity.isAllowedAccouting);
            }
        }        
        if(authority ==="accountingIsEnable"){
            if(this.userIdentity)
                return Promise.resolve(this.userIdentity.enableAccounting);
        }

        if(authority==="premiumCalculationIsEnable") {
            return Promise.resolve(this.userIdentity.enablePremiumCalculation);
        }

        if(!this.isStaff) {
            return Promise.resolve(true);
        }

        if(this.isStaff && CommonUtils.isNotNil(this.staffPermission)) {
            return Promise.resolve(this.checkPermissionAllowed(authority));
        }
        return Promise.resolve(false);
    }

    searchQuery(searchKey?: string,url?: string,req?: any): Observable<HttpResponse<any[]>> {
        // const options = createRequestOption(req);
        searchKey=searchKey.trim().replace('+','');
        searchKey=encodeURI(searchKey);
        return this.http.get<any[]>(this.resourceUrl+url+'?searchKey='+searchKey,{params: req,observe: 'response'});
    }

    getYearsFromStartAndEndDates(start, end) {
        // console.log(start.getFullYear());
        // console.log(end.getFullYear());
        let endYear = new Date().getFullYear() > end.getFullYear() ? end.getFullYear() : new Date().getFullYear();
        let arr = [];
        for(let startYear = start.getFullYear(); startYear <= endYear; startYear = startYear + 1){
            arr.push(startYear);
        }
        return arr;
    }

    getYearsFromStartAndEndYears(start, end) {
        // console.log(start);
        // console.log(end);
        let arr = [];
        for (start; start <= end; start++) {
            arr.push(start);
        }
        return arr;
    }

    dateFormateClientToServerCDate() {
        let d=new Date();
        d.setDate(d.getDate());
        let day=d.getDate();
        let month=d.getMonth()+1;
        let year=d.getFullYear();
        return year+'-'+month+'-'+day;
    }


    dateFormateClientToServer(date) {
        // input  { year: , month: , day:  }
        // output  yyyy/mm/dd 
        if(CommonUtils.isNotNil(date)) {
            let day=('0'+(date.day)).slice(-2);
            let month=('0'+(date.month)).slice(-2);
            let year=date.year;
            return year+'-'+month+'-'+day;
        }
    }

    dateFormateServerToClientMin(date) {
        if(date) {
            let d=new Date(date);
            d.setDate(d.getDate()-1);
            let day=d.getDate();
            let month=d.getMonth()+1;
            let year=d.getFullYear();
            return {year: year,month: month,day: day}
        }
    }
    dateFormateServerToClientMax(date) {
        if(date) {
            let d=new Date(date);
            d.setDate(d.getDate()+1);
            let day=d.getDate();
            let month=d.getMonth()+1;
            let year=d.getFullYear();
            return {year: year,month: month,day: day}
        }
    }
    dateFormateServerToClient(date) {
        // input  yyyy/mm/dd 
        // output { year: , month: , day:  }
        if(date) {
            let d
            if (date instanceof Date) {
                d = date;
            } else {
                d=new Date(date);
            }
            let day=d.getDate();
            let month=d.getMonth()+1;
            let year=d.getFullYear()
            return {year: year,month: month,day: day}
        }

    }

    dateFormateToDayDate() {
        // input  yyyy/mm/dd 
        // output { year: , month: , day:  }
        let d=new Date();
        let day=d.getDate();
        let month=d.getMonth()+1;
        let year=d.getFullYear()
        return {year: year,month: month,day: day}

    }

    dateFormateServerToClientMinusDay(date,days) {
        // input  yyyy/mm/dd 
        // output { year: , month: , day:  }
        if(date) {
            let d
            if(date instanceof Date) {

                d=date;
            } else {
                d=new Date(date);
            }
            d.setDate(d.getDate()-1);
            let day=d.getDate();
            let month=d.getMonth()+1;
            let year=d.getFullYear()
            
            return {year: year,month: month,day: day}
        }

    }

    isvalidToEnableEditAtDetail(profileId: number) {
        if(localStorage.getItem('profileId')) {
            let loggedInUserProfileId=JSON.parse(localStorage.getItem('profileId'));

            if(loggedInUserProfileId===profileId) {
                return true;
            }
        }
        return false;
    }
    // getIsStorageScope(): Observable<HttpResponse<any>> {

    //     return this.http.get<any>(this.resourceUrl + "client-policies-is-storage-scope", { observe: 'response' });
    // }

    // getStorageScope() {
    //     if (this.userIdentity.authorities[0] === 'CLIENT' || this.userIdentity.authorities[0] === 'CLIENT_STAFF') {
    //         this.getIsStorageScope().subscribe(data => {
    //             console.log(data);
    //             this.isStorageScope = data.body;

    //         });
    //     }

    // }
    sortData=function(column) {
        this.applySorting=true;
        this.reverseSort=(this.sortColumn==column)? !this.reverseSort:false;
        this.sortColumn=column;
    }

    getSortClass=function(column) {
        if(this.sortColumn==column) {
            return this.reverseSort
                ? 'arrow-down'
                :'arrow-up';
        }

        return 'sort-by';
    }
    isAssignedToUnderlyingBrokerOrUnderwriter(policyCreatedRole: string,assignToRole: string) {
        if((policyCreatedRole==RoleUtil.Role.INSURER||policyCreatedRole==RoleUtil.Role.INSURER_STAFF)&&(this.authority!=RoleUtil.Role.INSURER&&this.authority!=RoleUtil.Role.INSURER_STAFF)&&(assignToRole==RoleUtil.Role.UNDERWRITER||assignToRole==RoleUtil.Role.BROKER||assignToRole==RoleUtil.Role.BROKER_STAFF)) {
            return true;
        } else if((policyCreatedRole==RoleUtil.Role.UNDERWRITER||policyCreatedRole==RoleUtil.Role.UNDERWRITER_STAFF)&&(this.authority!=RoleUtil.Role.UNDERWRITER&&this.authority!=RoleUtil.Role.UNDERWRITER_STAFF)&&(assignToRole==RoleUtil.Role.BROKER||assignToRole==RoleUtil.Role.BROKER_STAFF)) {
            return true
        }
        return false;
    }

    hasStaffPermissionWithOutPromise(authority: string): boolean {
        if(!this.authenticated) {
            return false;
        }
        //for trader client and client staff 
        if(authority==='myBulkDeclaration') {
            if((this.authority===RoleUtil.Role.BROKER_STAFF||this.authority===RoleUtil.Role.UNDERWRITER_STAFF||this.authority===RoleUtil.Role.INSURER_STAFF)) {
                return this.staffPermission.myBulkDeclaration;
            }
            else if(this.userIdentity.typeOfClient === TypeOfClient.TRADER) {
                if(this.authority===RoleUtil.Role.CLIENT_STAFF&&this.userIdentity.isAllowedBulkDeclaration) {
                    return this.staffPermission.myBulkDeclaration;
                } else if(this.authority===RoleUtil.Role.CLIENT) {
                    return this.userIdentity.isAllowedBulkDeclaration;
                } else {
                    return false;
                }
            } else if(this.userIdentity.typeOfClient === TypeOfClient.FREIGHT_FORWARDER) {
                return false;
            }
            else {
                return true;
            }
        }

        if(authority==='vesselScreening') {
            if((this.authority===RoleUtil.Role.CLIENT_STAFF||this.authority===RoleUtil.Role.CLIENT) && !(this.userIdentity.typeOfClient === TypeOfClient.TRADER)) {
                return false;
            } else if(!this.isStaff) {
                return true;
            } else {
                return this.staffPermission.vesselScreening;
            }
            
        }

        if(!this.isStaff) {
            return true;
        }

        if(this.isStaff && CommonUtils.isNotNil(this.staffPermission)) {
            return this.checkPermissionAllowed(authority);
        }
        return false;
    }


    checkPermissionAllowed(authority: any): boolean {
        let permissionAllowed: boolean=false;

        if(authority==='brokerManagement') {
            permissionAllowed=this.staffPermission.brokerManagement;
        }
        if(authority==='underWriterManagement') {
            permissionAllowed=this.staffPermission.underWriterManagement;
        }
        if(authority==='insurerManagement') {
            permissionAllowed=this.staffPermission.insurerManagement;
        }
        if(authority==='internalStaffManagement') {
            permissionAllowed=this.staffPermission.internalStaffManagement;
        }
        if(authority==='clientMangement') {
            permissionAllowed=this.staffPermission.clientMangement;
        }
        if(authority==='auditorManagement') {
            permissionAllowed=this.staffPermission.auditorManagement;
        }
        if(authority==='readOnly') {
            permissionAllowed=this.staffPermission.readOnly;
        }
        if(authority==='dataManagement') {
            permissionAllowed=this.staffPermission.dataManagement;
        }

        if(authority==='cargoGroup') {
            permissionAllowed=this.staffPermission.cargoGroup;
        }
        if(authority==='certificate') {
            permissionAllowed=this.staffPermission.certificate;
        }
        if(authority==='classificationSoceity') {
            permissionAllowed=this.staffPermission.classificationSoceity;
        }
        if(authority==='clauseAndExtension') {
            permissionAllowed=this.staffPermission.clauseAndExtension;
        }
        /*  if (authority === 'myCertificates') {
             permissionAllowed = this.staffPermission.myCertificates;
         } */
        if(authority==='incoterandTradeterm') {
            permissionAllowed=this.staffPermission.incoterandTradeterm;
        }
        if(authority==='intraCountryBan') {
            permissionAllowed=this.staffPermission.intraCountryBan;
        }
        if(authority==='loadingPackingType') {
            permissionAllowed=this.staffPermission.loadingPackingType;
        }
        if(authority==='manualRequest') {
            permissionAllowed=this.staffPermission.manualRequest;
        }
        if(authority==='myCertificates') {
            permissionAllowed=this.staffPermission.myCertificates;
        }
        if(authority==='myInvoices') {
            permissionAllowed=this.staffPermission.myInvoices;
        }
        if(authority==='myOpenPolicy') {
            permissionAllowed=this.staffPermission.myOpenPolicy;
        }
        if(authority==='pAndIClub') {
            permissionAllowed=this.staffPermission.pAndIClub;
        }
        if(authority==='policyManagement') {
            permissionAllowed=this.staffPermission.policyManagement;
        }
        if(authority==='claimManagement') {
            permissionAllowed=this.staffPermission.claimManagement;
        }
        if(authority==='myDeclaration') {
            permissionAllowed=this.staffPermission.myDeclaration;
        }
        if(authority==='getDeclaration') {
            permissionAllowed=this.staffPermission.getDeclaration;
        }
        if(authority==='port') {
            permissionAllowed=this.staffPermission.port;
        }
        if(authority==='readOnlyBrokerData') {
            permissionAllowed=this.staffPermission.readOnlyBrokerData;
        }
        if(authority==='requestDetails') {
            permissionAllowed=this.staffPermission.requestDetails;
        }
        if(authority==='requestForPolicy') {
            permissionAllowed=this.staffPermission.requestForPolicy;
        }
        if(authority==='sanctionedCountry') {
            permissionAllowed=this.staffPermission.sanctionedCountry;
        }
        if(authority==='surveyCompanyAndAssociation') {
            permissionAllowed=this.staffPermission.surveyCompanyAndAssociation;
        }
        if(authority==='tax') {
            permissionAllowed=this.staffPermission.tax;
        }

        if(authority==='underwritersInsurer') {
            permissionAllowed=this.staffPermission.underwritersInsurer;
        }
        if(authority==='userManagement') {
            permissionAllowed=this.staffPermission.userManagement;
        }

        if(authority==='vesselInformation') {
            permissionAllowed=this.staffPermission.vesselInformation;
        }
        if(authority==='vesselInformationUploadCSV') {
            permissionAllowed=this.staffPermission.vesselInformationUploadCSV;
        }
        if(authority==='warStrikeRisk') {
            permissionAllowed=this.staffPermission.warStrikeRisk;
        }

        if(authority==='policyInfo') {
            permissionAllowed=this.staffPermission.policyInfo;
        }

        
        if(authority==='disableDeductibleFromCertificate') {
            if(this.authority==="CLIENT_STAFF") {
                permissionAllowed=this.staffPermission.disableDeductibleFromCertificate;
            } else {
                permissionAllowed=true;
            }

        }

        if(authority==='letterOfIndemnity') {
            if(this.authority==="CLIENT_STAFF") {
                permissionAllowed=this.staffPermission.letterOfIndemnity;
            } else {
                permissionAllowed=true;
            }

        }

        if(authority==='clientPolicyInfo') {
            //permissionAllowed = this.staffPermission.policyInfo;

            // if (this.staffPermission.policyInfo || this.userIdentity.isAllowedBulkDeclaration) {
            if(this.staffPermission.policyInfo) {
                permissionAllowed=true;
            } else {
                permissionAllowed=false;
            }
        }

        if(authority==="showDashBoard") {
            if(this.authority===RoleUtil.Role.CLIENT_STAFF&&!this.staffPermission.myCertificates&&!this.staffPermission.requestDetails) {
                permissionAllowed=false;
            } else if((this.authority===RoleUtil.Role.BROKER_STAFF||this.authority===RoleUtil.Role.UNDERWRITER_STAFF||this.authority===RoleUtil.Role.INSURER_STAFF)&&!this.staffPermission.myCertificates&&!this.staffPermission.manualRequest) {
                permissionAllowed=false;
            } else {
                permissionAllowed=true;
            }
        }

        if(authority==="showDashBoardViewButton") {
            if(this.authority===RoleUtil.Role.CLIENT_STAFF&&!this.staffPermission.requestDetails) {
                permissionAllowed=false;
            } else if((this.authority===RoleUtil.Role.BROKER_STAFF||this.authority===RoleUtil.Role.UNDERWRITER_STAFF||this.authority===RoleUtil.Role.INSURER_STAFF)&&!this.staffPermission.manualRequest) {
                permissionAllowed=false;
            } else {
                permissionAllowed=true;
            }
        }

        if(authority==='storageDeclaration') {
            permissionAllowed=this.staffPermission.storageDeclaration;
        }

        if(authority==='accounting') {
            permissionAllowed=this.staffPermission.accounting;
        }

        if(authority==='brokerRequestDetails') {
            permissionAllowed=this.staffPermission.brokerRequestDetails;
        }

        if(authority==='generateInvoice') {
            permissionAllowed=this.staffPermission.generateInvoice;
        }

        if(authority==='assignedBrokerStaffModify') { // only for assigned broker staff with all permissions for modification
            permissionAllowed=this.userIdentity&&this.userIdentity.isAssignedBrokerStaff&&this.staffPermission.policyManagement;
        }
        return permissionAllowed;
    }

    public setShowClaims(showClaims: boolean) {
        this.showClaims=showClaims;
    }

    public getShowClaim(): boolean {
        return this.showClaims;
    }

    public getShowSpot(): boolean {
        return this.showSpot;
    }

    public setShowSpot(showSpot: boolean) {
        this.showSpot=showSpot;
    }


    checkAccountingAccessForClient(): Promise<boolean> {
        if(!this.authenticated) {
            return Promise.resolve(false);
        }

        if(this.isStaff&&this.staffPermission!=null) {  // for client internal staff
            let allow: boolean=this.checkPermissionAllowed('accounting');  // for check in permissions
            if(allow) {
                return Promise.resolve(this.userIdentity.isAllowedAccouting); // if allowed then check by accounting allowed in policy level
            } else {
                return Promise.resolve(false);
            }
        } else {      // for client
            return Promise.resolve(this.userIdentity.isAllowedAccouting);  //  check by accounting allowed in policy level
        }

    }

    checkAccountingAccessForUser(): Promise<boolean> {
        return Promise.resolve(this.userIdentity.enableAccounting);
    }

    checkPremiumCalculationAccessForUser(): Promise<boolean> {
        return Promise.resolve(this.userIdentity.enablePremiumCalculation);

    }


    // close alert manually when its getting stuck on ui
    closeAlertManually(alertService: JhiAlertService) {
        let alertMessage: JhiAlert[]=alertService.get();
        alertMessage.forEach(alert => {
            alertService.closeAlert(alert.id);
        })
    }

    checkForBulkDeclaration() {
        return this.userIdentity.isAllowedBulkDeclaration;
    }
    
    checkForEnableSanctionScreening() {
        return this.userIdentity.enableSanctionsScreening;
    }
    
    checkForEnableSanctionScreeningForFinscanEntity(entity: FinscanEntity) {
        let enabled=this.userIdentity.enableSanctionsScreening;
        if(enabled) {
            return this.userIdentity.finscanOpportunities.filter(op => op.finscanEntity==entity&&op.enableSanctionScreening).length>0;
        } else {
            return false;
        }
    }

    checkForFinscanOppurtunitiesType(entity: FinscanEntity) {
        let enabled=this.userIdentity.enableSanctionsScreening;
        if(enabled) {
            if(this.userIdentity.finscanOpportunities.some(op => op.finscanEntity==entity&&op.enableAdHocMonitoring==true)) {
                return this.getApplicationId(this.login,true);
            } else if(this.userIdentity.finscanOpportunities.some(op => op.finscanEntity==entity&&op.enableContinuousMonitoring==true)) {
                return this.getApplicationId(this.login,false);
            }
        } else {
            return ''
        }
        
    }

    isAssignedBrokerStaff() {
        return this.userIdentity!=null&&this.userIdentity.isAssignedBrokerStaff;
    }

    isAssignedUnderwriterStaff() {
        return this.userIdentity!=null&&this.userIdentity.isAssignedUnderwriterStaff;
    }

    isHavingActivePolicy() {
        return this.userIdentity!=null&&this.userIdentity.isHavingActivePolicy;
    }

    getPolicyHolderId() {
        return this.userIdentity!=null&&this.userIdentity.policyHolderId;
    }


    public getApplicationId(login: Clients,isAdHoc:boolean){
        switch(login) {
            case Clients.VERHEYEN:
                return isAdHoc? FinsacnApplicationId.VERHEYEN_APPLICATION_ID_ADHOC:FinsacnApplicationId.VERHEYEN_APPLICATION_ID_CONTINOUS_MONITORING;
            case Clients.ATRALO:
                return isAdHoc? FinsacnApplicationId.ATRALO_APPLICATION_ID_ADHOC:FinsacnApplicationId.ATRALO_APPLICATION_ID_CONTINOUS_MONITORING;
            case Clients.MEIJERS:
                return isAdHoc? FinsacnApplicationId.MEIJERS_APPLICATION_ID_ADHOC:FinsacnApplicationId.MEIJERS_APPLICATION_ID_CONTINOUS_MONITORING;
            default:
                return isAdHoc? FinsacnApplicationId.ASIGEST_APPLICATION_ID_ADHOC:FinsacnApplicationId.ASIGEST_APPLICATION_ID_CONTINOUS_MONITORING;
        }
    }


    public checkForCertificateIfAssignedBroker(editPermission?:boolean) {
        if(this.isAssignedBrokerStaff()) {
            return this.staffPermission&&this.staffPermission.certificate;
        } else {
            return editPermission;
        }
    }
    
  
}
